module.exports = __webpack_public_path__ + "img/xianshang.e09afc84.png";